<template>
  <div class="container-fluid">
    <div class="row">
      <main id="nft-content" class="col" :class="{ 'active-sidebar': isSidebarOpen }">
        <SpinnerBackdrop v-if="isLoading" size="6rem" thickness="0.6rem" variant="info" />
        <div v-else>
          <DietPlan
            v-if="isSetted"
            v-model="diet"
            :indication-presets="indicationPresets"
            :example-presets="examplePresets"
            @remove-meal="removeMeal"
          />
          <DietSettings
            v-else
            ref="dietSettings"
            v-model="diet"
            @get-diet-suggestion="getPortionsSuggestion"
            @update-diet-plan="updateUnsettedDietPlan"
          />
        </div>
      </main>
      <DietPlanSidebar
        v-if="isSetted"
        @open="openSidebar"
        @close="closeSidebar"
        :patient-data="patient"
        :poll-data="poll"
        :diet-data="diet"
        :food-list="foodGroups"
        :food-details="foodDetails"
        :unsaved-changes="unsavedChanges"
        :is-saving="isSaving"
        :is-exporting="isExporting"
        :is-searching="isSearching"
        @add-meal="addMeal"
        @save-diet="saveDiet"
        @get-diet-file="getDietFile"
        @get-food-details="getFoodDetails"
      />
      <DietSettingsSidebar
        v-else
        @open="openSidebar"
        @close="closeSidebar"
        :patient-data="patient"
        :poll-data="poll"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DietSettings from "../components/diet/DietSettings"
import DietPlan from "../components/diet/DietPlan"
import dietService from "../services/dietService";
import patientService from "../services/patientService";
import DietSettingsSidebar from "../components/sidebar/DietSettingsSidebar";
import DietPlanSidebar from "../components/sidebar/DietPlanSidebar";
import SpinnerBackdrop from "../components/SpinnerBackdrop";
import slugify from "slugify"

export default {
  name: "DietPage",
  components: {
    DietSettings,
    DietPlan,
    DietSettingsSidebar,
    DietPlanSidebar,
    SpinnerBackdrop
  },
  data: function() {
    return {
      diet: {},
      poll: {},
      patient: {},
      indicationPresets: undefined,
      examplePresets: undefined,
      foodGroups: [], 
      foodDetails:{},
      isSidebarOpen: false,
      unsavedChanges: false,
      isSaving: false,
      isExporting: false,
      isLoading: true,
      isSearching: false,
      isSetted: false
    };
  },
  computed: {
    colorsHex: function() {
      return Object.keys(this.colorPresets);
    },
    isColorMenuOpen: function() {
      return this.$store.state.contextMenu.open;
    },
    ...mapState(["login"])
  },
  mounted: function() {
    if (this.$store.state.login.token) {
      this.getDietPlan();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.unsavedChanges) {
      const answer = window.confirm(
        "Tienes cambios sin guardar ¿Deseas salir?"
      );
      if (answer) {
        window.onbeforeunload = null;
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  methods: {
    openSidebar: function() {
      this.isSidebarOpen = true;
    },
    closeSidebar: function() {
      this.isSidebarOpen = false;
    },
    getDietPlan: function() {
      dietService
        .get_diet_plan({ id: this.$route.params.id })
        .then(
          data => {
            this.diet = data.diet_plan;
            this.isSetted = data.diet_plan.is_setted;
            this.indicationPresets = data.indication_presets;
            this.examplePresets = data.example_presets;
            this.poll = data.entry_poll;
            this.patient = data.patient;
            this.foodGroups = data.food_groups;
            this.isLoading = false;
          },
          // eslint-disable-next-line
          error => {
            this.$toasted.error("Ha ocurrido un error cargando datos de la pauta.");
          }
        );
    },
    getPortionsSuggestion: function () {
      this.diet.portions = []
      dietService
        .get_portions_suggestion({
          id: this.$route.params.id,
          requirements: this.diet.requirements,
          diet_type: this.diet.diet_type
        })
        .then(
          data => {
            data.portions.forEach(food => {
              food.portionsCalories = 0
              food.portionsCHO = 0
              food.portionsProtein = 0
              food.portionsLipid = 0
            });
            this.diet.portions = data.portions;
          },
          // eslint-disable-next-line
          error => {
            this.$toasted.error("Ha ocurrido un error cargando sugerencias de la pauta.");
          }
        );
    },
    updateUnsettedDietPlan: function() {
      this.$toasted.success("Enviando la información...");
      this.isLoading = true;
      let diet = this.diet
      for (const portions of diet.portions) {
        portions.diet_plan = this.$route.params.id
        //portions.food_group = portions.food_group.id
      }
      
      dietService
        .save_diet_plan({ form: diet, id: this.$route.params.id })
        .then(
          data => {
            this.$toasted.success(data.message);
            this.isLoading = false;
            this.unsavedChanges = false;
            this.$router.go(0);
          },
          // eslint-disable-next-line
          error => {
            this.$toasted.error("Ha ocurrido un error guardando la pauta.");
            this.isLoading = false;
          }
        );
    },
    getDietFile: function () {
      this.isExporting = true;
      let diet = this.diet;
      dietService
        .download_diet_plan({ form: diet, id: this.$route.params.id })
        .then(
          // eslint-disable-next-line
          data => {
            // create fake DOM element to download file
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = url;
            let patientName = slugify(this.patient.first_name + " " + this.patient.last_name, "_")
            let fileName = "pauta_alimentaria_" + patientName + ".docx"
            link.setAttribute("download", fileName); //or any other extension
            document.body.appendChild(link);
            // click it to start download
            this.isExporting = false;
            this.unsavedChanges = false;
            link.click();
            this.$toasted.success("Descarga exitosa!");
          },
          // eslint-disable-next-line
          error => {
            this.isExporting = false;
            this.$toasted.error(
              "Ha ocurrido un error descargando el plan!"
            );
          }
        )
    },
    saveDiet: function () {
      this.isSaving = true;
      let diet = this.diet;
      dietService
        .save_diet_plan({ form: diet, id: this.$route.params.id })
        .then(
          // eslint-disable-next-line
          data => {
            this.unsavedChanges = false;
            this.isSaving = false;
            this.$toasted.success("Guardado exitoso!");
          },
          // eslint-disable-next-line
          error => {
            this.isSaving = false;
            this.$toasted.error(
              "Ha ocurrido un error guardando el plan!"
            );
          }
        )
    },
    addMeal: function () {
      this.diet.meals.push({
        id: "new-meal-" + (this.diet.meals.length + 1),
        name: "Comida " + (this.diet.meals.length + 1),
        start_time: null,
        end_time: null,
        portions: [],
        examples: []
      });
      this.$nextTick(() => {
        window.scroll({
          top:
            document.body.scrollHeight || document.documentElement.scrollHeight,
          left: 0,
          behavior: "smooth"
        });
      });
    },
    removeMeal: function(mealIndex) {
      this.diet.meals.splice(mealIndex, 1);
    },
    getFoodDetails: function(foodIndex) {
      this.isSearching = true
      dietService
        .get_food_details({ dietId: this.$route.params.id, id: foodIndex })
        .then(
          // eslint-disable-next-line
          data => {
            this.foodDetails = data.food_group
            this.isSearching = false
          },
          // eslint-disable-next-line
          error => {
            this.isSearching = false
            this.$toasted.error(
              "No se pudo encontrar información!"
            );
          }
        )
    },
    saveProgram: function() {
      this.isSaving = true;
      patientService
        .save_program({ id: this.$route.params.id, program: this.programData })
        .then(
          // eslint-disable-next-line
          data => {
            this.unsavedChanges = false;
            this.isSaving = false;
            this.$toasted.success("Guardado exitoso!");
          },
          // eslint-disable-next-line
          error => {
            this.isSaving = false;
            this.$toasted.error(
              "Ha ocurrido un error guardando el plan!"
            );
          }
        );
    },
    getProgram: function() {
      patientService.get_program({ id: this.$route.params.id }).then(
        data => {
          this.programData = data.program;
          this.indicationPresets = data.indicationPresets;
          this.colorPresets = data.colorPresets;
          this.levelPresets = data.levelPresets;
          this.objectivePresets = data.objectivePresets;
        },
        // eslint-disable-next-line
        error => {
          this.$toasted.error("Ha ocurrido un error obteniendo el plan!");
        }
      );
    },
    addRoutine: function() {
      this.programData.routines.push({
        id: "new-routine-" + (this.programData.routines.length + 1),
        name: "Rutina " + (this.programData.routines.length + 1),
        days: [],
        exercises: [],
        cardio_start: null,
        cardio_end: null,
        has_exercises: true
      });
      this.$nextTick(() => {
        window.scroll({
          top:
            document.body.scrollHeight || document.documentElement.scrollHeight,
          left: 0,
          behavior: "smooth"
        });
      });
    },
    getProgramFile: function() {
      this.isExporting = true;
      patientService
        .get_program_file({
          id: this.$route.params.id,
          program: this.programData
        })
        .then(
          data => {
            // create fake DOM element to download file
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "programa_de_entrenamiento.docx"); //or any other extension
            document.body.appendChild(link);
            // click it to start download
            this.isExporting = false;
            this.unsavedChanges = false;
            link.click();
          },
          // eslint-disable-next-line
          error => {
            this.isExporting = false;
            this.$toasted.error("Ha ocurrido un error!");
          }
        );
    }
  },
  watch: {
    // eslint-disable-next-line
    "login.token": function(newValue, oldValue) {
      if (!newValue) {
        // eslint-disable-next-line
        this.$router.push({ name: "home" }).catch(err => {});
      }
    },
    "$route.params.id": function() {
      this.getDietPlan();
    },
    unsavedChanges(val) {
      window.onbeforeunload = val
        ? () => "Tienes cambios sin guardar ¿Deseas salir?"
        : null;
    },
    diet: {
      handler: function(val, oldVal) {
        if (oldVal.id && this.isSetted) {
          this.unsavedChanges = true;
        }
      },
      deep: true
    }
  }
};
</script>

<style scoped lang="scss">
#nft-content {
  padding-left: $content-padding-x;
  padding-right: $content-padding-x;
  padding-bottom: 10rem;
  min-width: 0;
  // transition: padding 0.3s;

  &.active-sidebar {
    padding-left: map-get($spacers, 2);
  }
}

.main-title {
  font-size: $h1-font-size;
  font-weight: bold;
  color: $body-color;
  margin: 2rem 0;
  text-align: center;
}

.add-indication-btn {
  margin: $spacer auto 0;
}

.indications-container {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid $gray-400;
  border-radius: 10px;
  padding: 0 map_get($spacers, 4) map_get($spacers, 4);
  margin: $spacer 0 $spacer * 4;
}

.routines-container {
  margin: 2rem 0;
}

.routines-enter-active,
.routines-leave-active {
  transition: opacity 0.5s ease-in;
}

.routines-enter,
.routines-leave-to {
  opacity: 0;
}
.dropdown-menu.show {
  z-index: 1025;
}
.program-select {
  border: 1px solid grey;
}
</style>
<style lang="scss">
.indications-container .dropdown-menu.show {
  z-index: 1025;
}
</style>